import i18n from '@ohif/i18n';
import { validatePasswordStrength } from '../passwordValidation';

const SETUP_ACCOUNT_NS = 'SetUpAccount';

const ENGLISH_TO_KEY: Record<string, string> = {
  'Password is required': 'passwordRequired',
  'Password must be at least 8 characters long': 'passwordTooShort',
  'Password must contain at least one lowercase letter': 'passwordMissingLowercase',
  'Password must contain at least one uppercase letter': 'passwordMissingUppercase',
  'Password must contain at least one number': 'passwordMissingNumber',
  'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>_+-=[]\\;\'~/`)':
    'passwordMissingSpecialChar',
  'Password can only contain letters, numbers, and special characters (!@#$%^&*(),.?":{}|<>_+-=[]\\;\'~/`)':
    'passwordInvalidChars',
};

export function translatePasswordError(message: string): string {
  if (!message) {
    return '';
  }
  const key = ENGLISH_TO_KEY[message];
  if (!key) {
    return message;
  }

  // These live nested under "errors" in SetUpAccount.json, but i18n is initialised with
  // keySeparator: false, which makes a dotted key a literal flat lookup and misses them.
  // Overriding the separator for this one call keeps the rest of the app's flat keys
  // working while still reaching a nested one.
  const translated = i18n.t(`errors.${key}`, {
    ns: SETUP_ACCOUNT_NS,
    keySeparator: '.',
  });

  // A miss returns the key itself. Showing "errors.passwordMissingSpecialChar" to
  // someone trying to pick a password is worse than showing the untranslated sentence,
  // so fall back to the English the validator already produced.
  return !translated || translated === `errors.${key}` ? message : translated;
}

export function validatePasswordStrengthI18n(password: string): string {
  return translatePasswordError(validatePasswordStrength(password));
}
